/* TODO: Import from seperate file or get from server */
export const $ERROR = Object.freeze({
	ERR_MISSING_ARG: {
		name: 'Argument Expected',
		message: 'Argument Expected',
		code: 100,
	},
	ERR_GUARD_EXCEPTION: {
		name: 'Guard Exception',
		message: 'Exception thrown in Guard',
		code: 101,
	},
	ERR_REQUEST_FAILED: {
		name: 'Request Failed',
		message: 'API request failed',
		code: 102,
	},
	ERR_TYPE: {
		name: 'Wrong Type',
		message: 'Argument is of incorrect type',
		code: 103,
	},
});

export function $Error(error, { parent, log = true, silent = false } = {}) {
	if (!error) $Error($ERROR.ERR_MISSING_ARG);

	const _error = { error, parent: parent };

	if (log) logError({ error: { _error, parent: parent } });

	if (!silent) throw new Error(JSON.stringify(_error));
}

function logError(errorData) {
	/* TODO: Implement logging to server*/
	if (errorData) console.error(errorData);
}

/* Make $Error available in global scope */
export function init() {
	window.$Error = $Error;
	window.$ERROR = $ERROR;
}

export default {
	$Error,
	$ERROR,
};
